import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "23-Acre Mega Development with Integrated Township",
    "Breathtaking Hill and River Views",
    "Four Serene Prayer Halls for Spiritual Tranquility",
  ];
  const highlights2 = [
    "Homes with Huge Balconies & Expansive Carpet Areas",
    "Just 5 Minutes from Mumbra Station",
    "Iconic G+2 Clubhouse with 33-Storey Residential Towers",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        We're proud to unveil YES CENTRAL's most prestigious launch yet - Yes
        Palm Riveria, also known as Grand Kausa City - a landmark 23-acre mega
        township nestled in the heart of Mumbra, Thane. Thoughtfully designed
        for aspirational living, the project redefines city life by combining
        convenience, luxury, and holistic community infrastructure.
        <br />
        Crafted by a developer with over 30+ years of legacy, 50+ successful
        projects, and 1 Lakh+ happy families, this iconic development is poised
        to become a self-sufficient ecosystem - complete with educational
        institutes, transport terminals, an auditorium, and a host of luxurious
        amenities. With homes starting from ₹65.49 Lacs, Yes Palm Riveria
        delivers unmatched value and a lifestyle of abundance in one of Thane's
        most strategic growth corridors.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
